export default __webpack_public_path__ + "assets/hr-video-placeholder.6e76a5a9.jpg";